import axios, { AxiosRequestConfig, Method } from "axios";

//* HTTP METHODS
export enum HTTP_METHODS {
    GET = "GET",
    POST = "POST",
    DELETE = "DELETE",
    PUT = "PUT",
    PATCH = "PATCH"
}

async function apiRequest<TResponse, TBody = any>(
    url: string,
    method: Method,
    body?: TBody,
    token?: string,
    signal?: AbortSignal
): Promise<TResponse> {

    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}` + url;
    const config: AxiosRequestConfig = {
        url: apiUrl,
        method: method,
        headers: {
            "Content-Type": "application/json",
        },
        data: body ?? undefined,
    };

    if (token) {
        config.headers!["Authorization"] = `Bearer ${token}`;
    }
    //* Attach AbortController signal to allow request cancellation
    if (signal) {
        config.signal = signal;
    }

    try {
        const response = await axios(config);
        return response.data as TResponse;
    } catch (error) {
        const status = axios.isAxiosError(error) ? error.response?.status : undefined;
        console.error("API request failed", {
            method,
            status: status ?? "network-or-client-error",
        });
        throw error;
    }
}

// --------------------------
//       WRAPPERS
// --------------------------

// GET → no body
export const apiGet = <TResponse>(
    url: string,
    token?: string,
    signal?: AbortSignal
) => apiRequest<TResponse>(url, HTTP_METHODS.GET, undefined, token, signal);

// POST → body optional
export const apiPost = <TResponse, TBody = any>(
    url: string,
    body: TBody,
    token?: string,
    signal?: AbortSignal
) => apiRequest<TResponse, TBody>(url, HTTP_METHODS.POST, body, token, signal);

// PUT → body optional
export const apiPut = <TResponse, TBody = any>(
    url: string,
    body: TBody,
    token?: string,
    signal?: AbortSignal
) => apiRequest<TResponse, TBody>(url, HTTP_METHODS.PUT, body, token, signal);

// DELETE → some APIs allow body, so optional
export const apiDelete = <TResponse, TBody = any>(
    url: string,
    body?: TBody,
    token?: string,
    signal?: AbortSignal
) => apiRequest<TResponse, TBody>(url, HTTP_METHODS.DELETE, body, token, signal);

// PATCH → body optional
export const apiPatch = <TResponse, TBody = any>(
    url: string,
    body: TBody,
    token?: string,
    signal?: AbortSignal
) => apiRequest<TResponse, TBody>(url, HTTP_METHODS.PATCH, body, token, signal);


//! old -- by fetch

// export async function apiRequest<TResponse, TBody = undefined>(
//     url: string,
//     method: HTTP_METHODS = HTTP_METHODS.GET,
//     token: string,
//     body?: TBody
// ): Promise<TResponse> {

//     try {
//         const headers: Record<string, string> = {
//             "Content-Type": "application/json",
//         };

//         if (token) {
//             headers["Authorization"] = `Bearer ${token}`;
//         }

//         const response = await fetch(url, {
//             method,
//             headers,
//             body: body ? JSON.stringify(body) : undefined,
//         });

//         return await response.json() as TResponse;
//     } catch (error) {
//         console.error("Error Api : ", error);
//         throw error;
//     }
// }

// export enum HTTP_METHODS {
//     GET = "GET",
//     POST = "POST",
//     DELETE = "DELETE",
//     PUT = "PUT",
//     PATCH = "PATCH"
// }
